
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.5 9.2a3.3 3.3 0 100 6.6 3.3 3.3 0 000-6.6zM11 12.5a5.5 5.5 0 1111 0 5.5 5.5 0 01-11 0z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.5 2.286a10.198 10.198 0 00-7.232 3.012 10.316 10.316 0 00-2.995 7.273c0 4.732 2.627 9.04 5.403 12.25A35.909 35.909 0 0016.5 29.43a35.909 35.909 0 004.824-4.607c2.776-3.211 5.403-7.52 5.403-12.25 0-2.729-1.077-5.345-2.995-7.274A10.198 10.198 0 0016.5 2.286zm0 28.571l-.652.936h-.001l-.003-.003-.008-.006-.03-.02a21.709 21.709 0 01-.485-.363c-.324-.25-.783-.614-1.332-1.084a38.192 38.192 0 01-4.028-3.996C7.055 22.961 4 18.126 4 12.571 4 9.237 5.317 6.04 7.661 3.682A12.464 12.464 0 0116.5 0c3.315 0 6.495 1.324 8.839 3.682A12.608 12.608 0 0129 12.572c0 5.554-3.055 10.388-5.96 13.75a38.19 38.19 0 01-4.028 3.995 33.216 33.216 0 01-1.714 1.37c-.045.034-.08.06-.105.077l-.029.02-.008.006-.003.002c-.001.001-.001.001-.653-.935zm0 0l.652.936a1.131 1.131 0 01-1.304 0l.652-.936z","fill":"currentColor"}})])
          )
        }
      }
    